import { PWA_APP_START_URL } from '@/constants/pwa';
import {
    carBatteryLanding,
    carEngineOilLanding,
    carInspection,
    freewayTollsLanding,
    trafficPlanLanding,
    vehicleFinesLanding
} from '@/constants/routes';

import { FaqItem, Feature, FooterLink, Review, ScreenshotSlide, Stat } from './models';

import { BatteryCharging, Bill, CardPos, Drop, Headphone, ShieldTick, TruckFast, Verify } from 'iconsax-react';

export const STORE_LINKS = {
    bazaar: 'https://cafebazaar.ir/app/com.azkiservice.app',
    myket: 'https://myket.ir/app/com.azkiservice.app',
    directApk: 'https://azkiservice.com/dl/azkiservice.apk',
    landing: 'https://azkiservice.com/download-app',
    pwa: PWA_APP_START_URL
} as const;

export const PAGE_URL = 'https://azkiservice.com/download-app';

export const FEATURES: Feature[] = [
    {
        id: 1,
        icon: BatteryCharging,
        title: 'تعویض باتری خودرو و موتور در محل',
        description: 'باتری اصل با گارانتی معتبر را آنلاین سفارش دهید؛ کارشناس ازکی‌سرویس در کمتر از یک ساعت در محل شما تعویض می‌کند.'
    },
    {
        id: 2,
        icon: Drop,
        title: 'خرید روغن موتور و فیلتر',
        description: 'روغن‌موتور برندهای معتبر را مقایسه و خرید کنید؛ تعویض روغن و فیلتر هوا و روغن در محل کار یا منزل انجام می‌شود.'
    },
    {
        id: 3,
        icon: Verify,
        title: 'کارشناسی خودرو و موتورسیکلت',
        description: 'قبل از خرید، خودرو یا موتور را توسط کارشناسان مجرب ازکی‌سرویس در محل کارشناسی کنید و با خیال راحت تصمیم بگیرید.'
    },
    {
        id: 4,
        icon: Bill,
        title: 'استعلام خلافی، عوارض و طرح ترافیک',
        description: 'خلافی خودرو، عوارض آزادراهی و طرح ترافیک را در چند ثانیه استعلام کنید و همان‌جا آنلاین پرداخت کنید.'
    },
    {
        id: 5,
        icon: CardPos,
        title: 'پرداخت امن، نقدی یا اقساطی',
        description: 'با کیف پول ازکی‌سرویس، پرداخت آنلاین امن یا خرید اقساطی، هزینه خدمات و محصولات را راحت‌تر مدیریت کنید.'
    },
    {
        id: 6,
        icon: Headphone,
        title: 'پشتیبانی در تمام مراحل سفارش',
        description: 'از ثبت سفارش تا اتمام کار، تیم پشتیبانی ازکی‌سرویس همراه شماست و به سوال‌ها و پیگیری‌ها پاسخ می‌دهد.'
    }
];

export const REVIEWS: Review[] = [
    {
        id: 10,
        image: '/images/userReview/man7.png',
        name: 'پویا مرادی',
        rate: 5,
        vehicleModel: 'TVS Apache RTR 200',
        description: 'اولین بار برای کارشناسی موتور از اپ استفاده کردم. کارشناس دقیق بود و چند نکته مهم گفت. تجربه خیلی خوبی بود.'
    },
    {
        id: 11,
        image: '/images/userReview/man1.png',
        name: 'سهیل کشاورز',
        rate: 5,
        vehicleModel: 'KTM Duke 250',
        description: 'کارشناسی موتور کامل و حرفه‌ای بود. همه‌چیز از داخل اپ قابل پیگیری بود و نتیجه را هم سریع گرفتم.'
    },
    {
        id: 12,
        image: '/images/userReview/man2.png',
        name: 'حسام رفیعی',
        rate: 5,
        vehicleModel: 'Honda CB150R',
        description: 'برای انتخاب موتور مشاوره گرفتم. پشتیبانی خوب بود و کمک کرد انتخاب درست‌تری داشته باشم.'
    },
    {
        id: 13,
        image: '/images/userReview/man3.png',
        name: 'امید صالحی',
        rate: 5,
        vehicleModel: 'پژو ۲۰۶',
        description: 'باتری ماشین وسط راه تمام شد. از اپ سفارش دادم و زودتر از انتظار آمدند و تعویض کردند.'
    },
    {
        id: 14,
        image: '/images/userReview/man4.png',
        name: 'سینا احمدی',
        rate: 4.5,
        vehicleModel: 'هیوندای النترا',
        description: 'تعویض روغن را در محل کارم انجام دادند. نوبت‌گیری در اپ ساده بود و قیمت‌ها شفاف بود.'
    },
    {
        id: 15,
        image: '/images/userReview/man5.png',
        name: 'کیان محمدی',
        rate: 5,
        vehicleModel: 'هوندا CBR650R',
        description: 'استعلام خلافی و پرداختش در اپ چند ثانیه طول کشید. دیگر لازم نیست چند سایت مختلف را چک کنم.'
    }
];

export const STATS: Stat[] = [
    { id: 1, value: 400, suffix: '+ هزار', label: 'کاربر فعال' },
    { id: 2, value: 4.6, decimals: 1, suffix: '', label: 'امتیاز میانگین کاربران' },
    { id: 3, value: 50, suffix: '+ هزار', label: 'سفارش موفق' }
];

export const HERO_HIGHLIGHTS = [
    { id: 1, icon: TruckFast, text: 'هماهنگی مراجعه کارشناس به محل شما' },
    { id: 2, icon: CardPos, text: 'مقایسه و خرید از فروشندگان معتبر' },
    { id: 3, icon: CardPos, text: 'پرداخت امن؛ نقدی یا اقساطی' },
    { id: 4, icon: ShieldTick, text: 'ضمانت اصالت کالا و گارانتی خدمات' }
] as const;

export const SCREENSHOT_SLIDES: ScreenshotSlide[] = [
    {
        id: 'appstore-01',
        src: '/images/screenshots/appstore-01.png',
        alt: 'صفحه اصلی اپلیکیشن ازکی‌سرویس؛ دسترسی به خدمات خودرو و موتورسیکلت'
    },
    {
        id: 'appstore-02',
        src: '/images/screenshots/appstore-02.png',
        alt: 'خرید و تعویض باتری خودرو در محل با اپلیکیشن ازکی‌سرویس'
    },
    {
        id: 'appstore-03',
        src: '/images/screenshots/appstore-03.png',
        alt: 'سفارش تعویض روغن موتور و خدمات دوره‌ای خودرو در ازکی‌سرویس'
    },
    {
        id: 'appstore-04',
        src: '/images/screenshots/appstore-04.png',
        alt: 'درخواست کارشناسی خودرو قبل از خرید از طریق اپلیکیشن ازکی‌سرویس'
    },
    {
        id: 'appstore-05',
        src: '/images/screenshots/appstore-05.png',
        alt: 'استعلام و پرداخت خلافی خودرو در اپلیکیشن ازکی‌سرویس'
    },
    {
        id: 'appstore-06',
        src: '/images/screenshots/appstore-06.png',
        alt: 'پیگیری خدمات سیار ازکی‌سرویس تا رسیدن کارشناس به محل شما'
    }
];

export const FAQS: FaqItem[] = [
    {
        id: 1,
        question: 'چطور اپلیکیشن ازکی‌سرویس را دانلود کنم؟',
        answer: 'برای گوشی‌های اندروید می‌توانید اپلیکیشن را از مایکت یا کافه‌بازار دانلود کنید. کاربران آیفون هم می‌توانند با ورود به app.azkiservice.com نسخه وب‌اپ (PWA) را به صفحه اصلی گوشی اضافه کنند.'
    },
    {
        id: 2,
        question: 'اپلیکیشن ازکی‌سرویس چه خدماتی دارد؟',
        answer: 'در اپ ازکی‌سرویس می‌توانید تعویض باتری و روغن در محل، کارشناسی خودرو و موتور، خرید لوازم و قطعات، استعلام خلافی، عوارض آزادراهی و طرح ترافیک را انجام دهید و آنلاین پرداخت کنید.'
    },
    {
        id: 3,
        question: 'آیا خدمات ازکی‌سرویس در محل انجام می‌شود؟',
        answer: 'بله. بسیاری از خدمات مثل تعویض باتری، تعویض روغن و کارشناسی در محل شما انجام می‌شود. زمان مراجعه کارشناس بر اساس محدوده و زمان‌بندی سرویس با شما هماهنگ می‌شود.'
    },
    {
        id: 4,
        question: 'آیا نسخه iOS اپلیکیشن ازکی‌سرویس موجود است؟',
        answer: 'نسخه Native برای iOS هنوز منتشر نشده؛ اما می‌توانید در سافاری به app.azkiservice.com بروید و با گزینه Add to Home Screen، آیکون ازکی‌سرویس را به صفحه اصلی آیفون اضافه کنید.'
    },
    {
        id: 5,
        question: 'آیا امکان پرداخت اقساطی در اپ وجود دارد؟',
        answer: 'بله. علاوه بر پرداخت آنلاین و کیف پول، برای بخشی از خدمات و محصولات امکان پرداخت اقساطی هم فراهم است تا هزینه را راحت‌تر مدیریت کنید.'
    },
    {
        id: 6,
        question: 'دانلود و استفاده از اپلیکیشن رایگان است؟',
        answer: 'بله. دانلود و نصب اپلیکیشن ازکی‌سرویس رایگان است. فقط هزینه خدمات یا محصولاتی که سفارش می‌دهید طبق قیمت اعلام‌شده در اپ محاسبه می‌شود.'
    }
];

export const FOOTER_LINKS: FooterLink[] = [
    { id: 1, label: 'تعویض باتری خودرو', href: carBatteryLanding },
    { id: 2, label: 'تعویض روغن موتور', href: carEngineOilLanding },
    { id: 3, label: 'کارشناسی خودرو', href: carInspection },
    { id: 4, label: 'استعلام خلافی', href: vehicleFinesLanding },
    { id: 5, label: 'عوارض آزادراهی', href: freewayTollsLanding },
    { id: 6, label: 'طرح ترافیک', href: trafficPlanLanding }
];

export const DOWNLOAD_APP_SEO_SCHEMA = [
    {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'ازکی‌سرویس',
        operatingSystem: 'Android, iOS (PWA)',
        applicationCategory: 'LifestyleApplication',
        description:
            'اپلیکیشن ازکی‌سرویس برای تعویض باتری و روغن در محل، کارشناسی خودرو و موتور، استعلام خلافی، عوارض آزادراهی و طرح ترافیک با امکان پرداخت آنلاین و اقساطی.',
        url: PAGE_URL,
        image: 'https://azkiservice.com/images/logo/Azkiservice_App_Icon.png',
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'IRR'
        },
        author: {
            '@type': 'Organization',
            name: 'ازکی‌سرویس',
            url: 'https://azkiservice.com'
        }
    },
    {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'دانلود اپلیکیشن ازکی‌سرویس',
        url: PAGE_URL,
        description: 'دانلود رایگان اپلیکیشن ازکی‌سرویس برای اندروید و نصب نسخه iOS به‌صورت وب‌اپ؛ خدمات خودرو و موتور در محل با ضمانت کیفیت.',
        inLanguage: 'fa-IR',
        isPartOf: {
            '@type': 'WebSite',
            name: 'ازکی‌سرویس',
            url: 'https://azkiservice.com'
        }
    }
];
